module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_6_3.6446d06c.png";